
import { AiOutlineLoading } from 'react-icons/ai';
import styled from 'styled-components';

const SpinnerContainer = styled.div`
	align-items: center;
	display: flex;
	height: 100%;
	justify-content: center;
	width: 100%;
	svg {
		animation: rotate .7s ease infinite;
		color: ${({theme}) => theme.color.red};
		font-size: 2.5em;
		text-align: center;
		@keyframes rotate {
			100% {
				transform: rotate(360deg);
			}
		}
	}
`;

const Spinner = () => {
	return (
		<SpinnerContainer>
			<AiOutlineLoading />
		</SpinnerContainer>
	);
};

export default Spinner;
